export function tapInput() {
    let inputFields = document.querySelectorAll('[data-tapInput]');

    inputFields.forEach((tapField) => {
        let textField = tapField.querySelector('input');
        let lessBtn = tapField.querySelector('[data-tapInputLess]');
        let moreBtn = tapField.querySelector('[data-tapInputMore]');
        let min = parseInt(textField.getAttribute('min'));
        let currentValue = parseInt(textField.value);

        function less() {
            currentValue = parseInt(textField.value);

            if ((currentValue - 1) >= min) {
                --currentValue;
                textField.value = currentValue;
            }
        }

        function more() {
            currentValue = parseInt(textField.value);
            currentValue++;
            textField.value = currentValue;
        }

        lessBtn.addEventListener('click', (evt) => less());
        moreBtn.addEventListener('click', (evt) => more());

    })
}
